module.exports = __webpack_public_path__ + "static/img/QRCode.5b58c4bf.png";